export default "__VITE_ASSET__DUBn49w4__"